import ZlbConfirm from '@/components/ZlbConfirm';
import { verifyCorporateInfo } from 'src/common/services/unit';
import {
  beginnerProcess,
  checkInvites,
  completeMobile,
  getActiveRankDetail,
  getBoundOfficialCard,
  getDivisionRanking,
  getGendertype,
  getInstitutionTask,
  getMobileCode,
  getNotice,
  getOnlineRankDetail,
  getOperatorBannerList,
  getPageInfo,
  nextStep,
  readNotice,
  reqActivation,
  reqArticleList,
  reqAuthority,
  reqConfirmInfo,
  reqContent,
  reqDetail,
  reqInstitutionAdmin,
  reqMyApproval,
  reqMyForm,
  reqNeedCompleteBankInfo,
  reqReceiveList,
  reqSubmitConfirmInfo,
  reqSubmittedList,
} from '../services';

const responseErrorHandle = res => {
  const { success, message, statusText } = res;
  if (!success && (message || statusText)) {
    ZlbConfirm({
      title: message || statusText,
      cancelText: '知道了',
      showOkBtn: false,
    });
  }
  return success;
};

export default {
  namespace: 'controlPlatform',
  state: {
    tableQueryParams: {
      pageNo: 1,
      pageSize: 5,
    },
    // permission: false,
    mobileData: {},
    officialData: {},
    submittedList: {},
    receiveList: {},
    contentList: {},
    authorityList: [],
    isGovernmentEmployee: null,
    showOfficialCardTips: false,
  },
  effects: {
    //  权限获取
    // *fetchPermission({ payload }, { call, put }) {
    //   const res = yield call(reqPermission, payload);
    //   responseErrorHandle(res);
    //   yield put({
    //     type: 'update',
    //     payload: {
    //       permission: res.result || false,
    //     },
    //   });
    // },

    // 查询是否是公务员
    // *fetchPersonStatus({ payload }, { call, put }) {
    //   const res = yield call(reqNeedCompleteBankInfo, payload);
    //   responseErrorHandle(res);
    //   const { result = false } = res;
    //   yield put({
    //     type: 'update',
    //     payload: {
    //       showOfficialCardTips: result,
    //     },
    //   });
    // },
    *reqNeedCompleteBankInfo({ payload }, { call, put }) {
      const res = yield call(reqNeedCompleteBankInfo, payload);

      responseErrorHandle(res);
      const { result = false } = res;
      yield put({
        type: 'update',
        payload: {
          showOfficialCardTips: result,
          // showOfficialCardTips: true,
        },
      });
    },
    *fetchSubmittedList({ payload }, { call, put }) {
      const res = yield call(reqSubmittedList, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          submittedList: res.result || {},
        },
      });
    },

    *fetchReceiveList({ payload }, { call, put }) {
      const res = yield call(reqReceiveList, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          receiveList: res.result || {},
        },
      });
    },

    *confirmUserInfo({ payload }, { call, put }) {
      const res = yield call(reqConfirmInfo, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          mobileData: res.result || {},
        },
      });
      return res;
    },

    *submitConfirmInfo({ payload }, { call }) {
      const res = yield call(reqSubmitConfirmInfo, payload);
      responseErrorHandle(res);
      return res;
    },

    // 内容列表
    *content({ payload }, { call, put }) {
      const res = yield call(reqContent, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          contentList: res.result || {},
        },
      });
    },
    // 内容列表
    *reqArticleList({ payload }, { call, put }) {
      const res = yield call(reqArticleList, payload);
      responseErrorHandle(res);
      // yield put({
      //   type: 'update',
      //   payload: {
      //     articleList: res.result,
      //   },
      // });
      return res;
    },

    // 详情
    *detail({ payload }, { call, put }) {
      const res = yield call(reqDetail, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          detail: res.result,
        },
      });
      return res;
    },

    // 业务权限
    *fetchAuthority({ payload }, { call, put }) {
      const res = yield call(reqAuthority, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          authorityList: res.result || [],
        },
      });
      return res;
    },

    // 我的单据
    *fetchMyFormList({ payload }, { call, put }) {
      const res = yield call(reqMyForm, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          submittedList: res?.result || {},
        },
      });
    },

    // 我的审批
    *fetchMyApprovalList({ payload }, { call, put }) {
      const res = yield call(reqMyApproval, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          receiveList: res?.result || {},
        },
      });
    },
    // 激活信息获取
    *reqInviteInfo({ payload = {} }, { call }) {
      const res = yield call(reqActivation, payload);
      responseErrorHandle(res);
      return res;
    },
    // 激活信息获取
    *getBoundOfficialCard({ payload = {} }, { call }) {
      const res = yield call(getBoundOfficialCard, payload);
      responseErrorHandle(res);
      return res;
    },

    // 获取区划排行
    *getDivisionRanking({ payload = {} }, { call }) {
      const res = yield call(getDivisionRanking, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取上线率详情
    *getOnlineRankDetail({ payload = {} }, { call }) {
      const res = yield call(getOnlineRankDetail, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取活跃度详情
    *getActiveRankDetail({ payload = {} }, { call }) {
      const res = yield call(getActiveRankDetail, payload);
      responseErrorHandle(res);
      return res;
    },
    // 公告弹窗
    *getNotice({ payload = {} }, { call }) {
      const res = yield call(getNotice, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取活跃度详情
    *readNotice({ payload = {} }, { call }) {
      const res = yield call(readNotice, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取活跃度详情
    *checkInvites({ payload = {} }, { call }) {
      const res = yield call(checkInvites, payload);
      responseErrorHandle(res);
      return res;
    },
    // 流程信息查询
    *getBeginnerProcess({ payload = {} }, { call }) {
      const res = yield call(beginnerProcess, payload);
      responseErrorHandle(res);
      return res;
    },
    // 页面信息查询
    *getPageInfo({ payload = {} }, { call }) {
      const res = yield call(getPageInfo, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取性别枚举集合
    *getGendertype({ payload = {} }, { call }) {
      const res = yield call(getGendertype, payload);
      responseErrorHandle(res);
      return res;
    },
    // 下一步操作
    *nextStep({ payload = {} }, { call }) {
      const res = yield call(nextStep, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取单位管理岗id
    *fetchInstitutionAdmin({ payload }, { call }) {
      const res = yield call(reqInstitutionAdmin, payload);
      responseErrorHandle(res);
      return res;
    },

    // 获取验证码
    *getMobileCode({ payload }, { call }) {
      const res = yield call(getMobileCode, payload);
      responseErrorHandle(res);
      return res;
    },

    // 修改新手机号保存
    *completeMobile({ payload }, { call }) {
      const res = yield call(completeMobile, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取自己可见的 Banner 列表，首页使用
    *getOperatorBannerList({ payload }, { call }) {
      const res = yield call(getOperatorBannerList, payload);
      responseErrorHandle(res);
      return res;
    },

    // 获取机构需要提示的任务
    *getInstitutionTask({ payload }, { call }) {
      const res = yield call(getInstitutionTask, payload);
      return res;
    },

    // 统一社会信用代码验证
    *verifyCorporateInfo({ payload }, { call }) {
      const res = yield call(verifyCorporateInfo, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
